module.exports = __webpack_public_path__ + "media/images/official/kv_pc3-ee2be1327db600d094ea1374a14bafbb.webp";